export default "__VITE_ASSET__BEl3gBAE__"